var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","rounded":"","icon":""},on:{"click":_vm.updateTheme}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('v-icon',[_vm._v(_vm._s(_vm.themeIcon))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }